import script from "./deleteAccount.vue?vue&type=script&lang=ts&setup=true"
export * from "./deleteAccount.vue?vue&type=script&lang=ts&setup=true"

import "./deleteAccount.vue?vue&type=style&index=0&id=101c560a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-101c560a"]])

export default __exports__